export const FEEDBACK_SECTION_ID_QUALIFICATION = '9d4553bc-4abe-4dcd-b69f-d0a1d886da30';
export const FEEDBACK_SECTION_ID_MATCHING = 'bf48a24b-405e-48f7-9627-4eb9bc86295a';
